class ScrollAnimation {
    constructor() {
        this.windowHeight = window.innerHeight;
        this.sections = document.querySelectorAll('section');
        this.sectionLength = this.sections.length;
        this.navigation = document.querySelector('.coordinates');
        this.cords = this.navigation.querySelectorAll('.coordinate');
        this.line = this.navigation.querySelector('.cords-line');
        this.headerHeight = 72;
        this.spacingAround = 300;
        this.linkInnerHeight = 20;
    }

    initCoords() {
        this.windowHeight = window.innerHeight;
        this.linkHeight =
            (this.windowHeight - this.headerHeight - this.spacingAround) /
            2 /
            this.sectionLength;
        this.cords.forEach((cord) => {
            cord.style.padding = `${this.linkHeight}px 0px`;
        });
        this.line.style.height = `${this.linkHeight * 2 + this.linkInnerHeight}px`;
    }

    animationOnScroll() {
        const scrollTop = window.scrollY;
        this.sections.forEach((section, i) => {
            if (
                section.offsetTop < scrollTop + this.windowHeight / 2 &&
                scrollTop < section.offsetTop + this.windowHeight / 2
            ) {
                this.line.style.top = `${
                    ((this.windowHeight - this.headerHeight - this.spacingAround) /
                        this.sectionLength +
                        this.linkInnerHeight) *
                    i
                }px`;

                if(i > 0) {
                    this.navigation.style.opacity = 1;
                    this.navigation.style.visibility = 'visible';
                } else {
                    this.navigation.style.opacity = 0;
                    this.navigation.style.visibility = 'hidden';
                }
            }
        });
    }

    get navItems(){
        return this.navigation;
    }
}

export default ScrollAnimation;